export const STRIPE_BILLING_URL = import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL_URL as string
export const ECHOES_ENABLED = import.meta.env.VITE_ECHOES_ENABLED === "true"
